<div class="container-fluid px-0" *ngIf="sdkInitTexts">
  <div class="row my-0 mx-0">
    <div class="col-12 px-0 d-flex justify-content-center">
      <img class="logo" [src]="'assets/images/plogo.svg'" [srcset]="'assets/images/plogo@2x.svg 2x, assets/images/plogo@3x.svg 3x'" alt="logo"/>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <label
        class="what-is-paycell-title">{{this.textService.keyValueMapping('whatsPaycellPopupHeader', 'Paycell Nedir?', sdkInitTexts)}}</label>
    </div>
    <!--mobilde farklı pc de farklı görünüm olduğu için böyle bir şey yapıldı ekran boyutu 600 den küçükte mobil büyükte mobil yazmayanlar çalışır.-->
    <div class="col-12 px-0">
      <!--mobil-->
      <div class="col-12"><img class="content-logo-mobil" [src]="'assets/images/small-paycell.png'" [srcset]="'assets/images/small-paycell@2x.png 2x, assets/images/small-paycell@3x.png 3x'" alt="logo"/></div>
      <div class="col-12"><label
        class="content-paycell-title-mobil">{{this.textService.keyValueMapping('whatsPaycellPopupText1', 'PAYCELL HAYATIN HER YERİNDE', sdkInitTexts)}}</label><label
        class="content-paycell-body-mobil">{{this.textService.keyValueMapping('whatsPaycellPopupDescription1', 'Paycell finansal günlük ihtiyaçlarını karşılayabileceğin yeni nesil ödeme platformdur.', sdkInitTexts)}}</label>
      </div>
      <!--mobil olmayan-->
      <div class="col-12 box-image">
        <div><img class="content-logo" [src]="'assets/images/small-paycell.png'" [srcset]="'assets/images/small-paycell@2x.png 2x, assets/images/small-paycell@3x.png 3x'" alt="logo"/></div>
        <div><label
          class="content-paycell-title">{{this.textService.keyValueMapping('whatsPaycellPopupText1', 'PAYCELL HAYATIN HER YERİNDE', sdkInitTexts)}}</label>
          <label
            class="content-paycell-body">{{this.textService.keyValueMapping('whatsPaycellPopupDescription1', 'Paycell finansal günlük ihtiyaçlarını karşılayabileceğin yeni nesil ödeme platformdur.', sdkInitTexts)}}</label>
        </div>
      </div>
    </div>
    <div class="col-12 px-0">
      <!--mobil-->
      <div class="col-12"><img class="content-logo-mobil" [src]="'assets/images/hand.png'" [srcset]="'assets/images/hand@2x.png 2x, assets/images/hand@3x.png 3x'" alt="logo"/></div>
      <div class="col-12"><label
        class="content-paycell-title-mobil">{{this.textService.keyValueMapping('whatsPaycellPopupText2', 'TEK TIKLA GÜVENLİ VE KOLAY ÖDEME', sdkInitTexts)}}</label><label
        class="content-paycell-body-mobil">
        {{this.textService.keyValueMapping('whatsPaycellPopupDescription2', 'Anlaşmalı Paycell noktalarında Paycell’e kaydettiğiniz kredi/banka kartlarınızla ya da Turkcell faturanıza yansıtarak online alışverişlerinizde tek tıkla güvenli ödeme yaparsınız.', sdkInitTexts)}}
      </label></div>
      <!--mobil olmayan-->
      <div class="col-12 box-image-2">
        <div><img class="content-logo" [src]="'assets/images/hand.png'" [srcset]="'assets/images/hand@2x.png 2x, assets/images/hand@3x.png 3x'" alt="logo"/></div>
        <div><label
          class="content-paycell-title">{{this.textService.keyValueMapping('whatsPaycellPopupText2', 'TEK TIKLA GÜVENLİ VE KOLAY ÖDEME', sdkInitTexts)}}</label>
          <label class="content-paycell-body">
            {{this.textService.keyValueMapping('whatsPaycellPopupDescription2', 'Anlaşmalı Paycell noktalarında Paycell’e kaydettiğiniz kredi/banka kartlarınızla ya da Turkcell faturanıza yansıtarak online alışverişlerinizde tek tıkla güvenli ödeme yaparsınız.', sdkInitTexts)}}
          </label>
        </div>
      </div>
    </div>
    <div class="col-12 px-0">
      <!--mobil-->
      <div class="col-12"><img class="content-logo-mobil" [src]="'assets/images/coffee.png'" [srcset]="'assets/images/coffee@2x.png 2x, assets/images/coffee@3x.png 3x'" alt="logo"/></div>
      <div class="col-12"><label
        class="content-paycell-title-mobil">{{this.textService.keyValueMapping('whatsPaycellPopupText3', 'KULLANDIKÇA KAZAN', sdkInitTexts)}}</label><label
        class="content-paycell-body-mobil">
        {{this.textService.keyValueMapping('whatsPaycellPopupDescription3', 'Paycell’le bazı harcamalarınızdan puan biriktirir, bu puanlarınızla internet ya da birçok markanın hediye çeklerini alırsınız.', sdkInitTexts)}}
      </label></div>
      <!--mobil olmayan-->
      <div class="col-12 box-image-2">
        <div><img class="content-logo" [src]="'assets/images/coffee.png'" alt="logo"/></div>
        <div><label
          class="content-paycell-title">{{this.textService.keyValueMapping('whatsPaycellPopupText3', 'KULLANDIKÇA KAZAN', sdkInitTexts)}}</label>
          <label
            class="content-paycell-body">{{this.textService.keyValueMapping('whatsPaycellPopupDescription3', 'Paycell’le bazı harcamalarınızdan puan biriktirir, bu puanlarınızla internet ya da birçok markanın hediye çeklerini alırsınız.', sdkInitTexts)}}</label>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-center">
      <button class="button-style" (click)="close()"><span class="text-style">Anladım</span></button>
    </div>
  </div>
</div>

